export default "__VITE_ASSET__CyYkl0zt__"